import AEBlockGallery from './gallery-controller.js';

document.addEventListener('DOMContentLoaded', () => {
	const allSlideshows = document.querySelectorAll('.carousel');
	allSlideshows.forEach(function (currentSlideshow) {
		new AEBlockGallery(
			currentSlideshow,
			currentSlideshow.classList.contains('force-captions')
		);
	});
});
